'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Namespacing our constants the same way `react-router-redux does`
 */
var SHOW_LOADMASK = exports.SHOW_LOADMASK = '@@loadmask/SHOW_LOADMASK';
var HIDE_LOADMASK = exports.HIDE_LOADMASK = '@@loadmask/HIDE_LOADMASK';


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-redux-loadmask/lib/shared/constants.js
 ** module id = 221
 ** module chunks = 0
 **/